import ajax from '../http/ajax'

export const getCarBrand = params => {
    return ajax.get('getCarBrand', params)
}
